import parse from 'html-react-parser';
import React from 'react';
import alertIcon from '../../../assets/images/alertIcon.svg';
import useShowUserAlert from '../../../hooks/useShowUserAlert';
import LinkButton from '../../common/LinkButton';

type Props = {
    isDataRoom?: boolean;
    text_div_className?: string;
    align?: string;
    isDealAllow?: boolean;
    parentDivClassName?: string;
};

const UserAlret: React.FC<Props> = ({
    isDataRoom,
    text_div_className = 'flex md:flex-row flex-col md:items-center gap-1',
    align = 'md:justify-center',
    isDealAllow = false,
    parentDivClassName = '',
}) => {
    const { isShow, countText, isShowButton, redirectToSetting } = useShowUserAlert(isDealAllow);

    if (!isShow) {
        return null;
    }

    return (
        <div
            // className={`${currentPath.includes(HEADERMENU_PATH.settings) ? 'mt-1' : 'mt-3 md:mt-1'}  ${
            //     currentPath.includes(`${HEADERMENU_PATH.investments}`) ? 'mx-6 md:mt-3 mb-3 md:mb-1' : 'mb-1'
            // }`}
            className={parentDivClassName}
        >
            <div
                className="p-4 relative md:p-4 cursor-pointer md:py-2"
                style={{
                    // boxShadow: `0px 4px 4px rgba(0, 0, 0, 0.25)`,a
                    backgroundColor: '#D6FDE6',
                    border: '1px solid #27AE60',
                }}
            >
                <div className={`flex gap-2 md:items-center justify-start ${align}`}>
                    <div className="w-9">
                        <img src={alertIcon} alt="alert" />
                    </div>
                    <div className={text_div_className}>
                        <p className="text-[#20222B] font-[Lato] text-sm">
                            {isDataRoom ? (
                                `You don't have access to Data Room for this Deal`
                            ) : (
                                <span className="text-sm">{parse(countText)}</span>
                            )}
                        </p>
                        {isShowButton && (
                            <LinkButton
                                title="Review & Complete"
                                onClick={() => {
                                    redirectToSetting();
                                }}
                                isArrow={true}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserAlret;

export const shortMessage: any = {
    PendingKYCAdditionalDetails: {
        label: `You are required to provide some additional KYC details`,
        button: 'Please review and complete',
        showLimitedText: false,
    },
    PendingAIAdditionalDetails: {
        label: `You are required to provide some additional AI details`,
        button: 'Please review and complete',
        showLimitedText: false,
    },
    PendingKYCSubmission: {
        label: `Your KYC is not yet completed`,
        button: 'Please review and complete',
        showLimitedText: true,
    },
    PendingAISubmission: {
        label: `Your accreditation is not yet completed`,
        button: 'Please review and complete',
        showLimitedText: true,
    },
    PendingPostAIAgreements: {
        label: `Your post KYC platform agreements are pending completion`,
        button: 'Please review and complete',
        showLimitedText: true,
    },
    PendingKYCReview: {
        label: `Our team is currently reviewing your details. You will be updated once complete. If you have any queries, please contact us at <a href="mailto:admin@heli-cap.com" class="text-blue-400">admin@heli-cap.com</a>`,
        button: '',
        showLimitedText: false,
    },
    PendingAIReview: {
        label: `Our team is currently reviewing your details. You will be updated once complete. If you have any queries, please contact us at <a href="mailto:admin@heli-cap.com" class="text-blue-400">admin@heli-cap.com</a>`,
        button: '',
        showLimitedText: false,
    },
    PendingKYCResubmissionReview: {
        label: `Our team is currently reviewing your details. You will be updated once complete. If you have any queries, please contact us at <a href="mailto:admin@heli-cap.com" class="text-blue-400">admin@heli-cap.com</a>`,
        button: '',
        showLimitedText: false,
    },
    PendingAIResubmissionReview: {
        label: `Our team is currently reviewing your details. You will be updated once complete. If you have any queries, please contact us at <a href="mailto:admin@heli-cap.com" class="text-blue-400">admin@heli-cap.com</a>`,
        button: '',
        showLimitedText: false,
    },
    PendingAIResubmission: {
        label: `Your accreditation information requires reviewing. <a class="text-blue-400">Click here to review</a>`,
        button: 'Click here to review',
        showLimitedText: false,
    },
    PendingKYCResubmission: {
        label: `Your KYC information requires reviewing. <a class="text-blue-400">Click here to review</a>`,
        button: 'Click here to review',
        showLimitedText: false,
    },
    Rejected: {
        label: `If you have any queries, please contact us at <a href="mailto:admin@heli-cap.com" class="text-blue-400">admin@heli-cap.com</a>`,
        button: '',
        showLimitedText: false,
    },
};
